import * as React from "react";

function Nodata(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={438.547}
      height={129.338}
      viewBox="0 0 438.547 129.338"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={10.11}
          y1={10.738}
          x2={10.292}
          y2={10.836}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={5.347}
          y1={5.395}
          x2={5.353}
          y2={5.41}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__c"
          x1={26.232}
          y1={27.492}
          x2={26.877}
          y2={27.801}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__d"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#12b9ff" stopOpacity={0.698} />
          <stop offset={0.007} stopColor="#fff" stopOpacity={0.69} />
          <stop offset={0.133} stopColor="#fff" stopOpacity={0.51} />
          <stop offset={0.264} stopColor="#fff" stopOpacity={0.353} />
          <stop offset={0.397} stopColor="#fff" stopOpacity={0.224} />
          <stop offset={0.534} stopColor="#fff" stopOpacity={0.125} />
          <stop offset={0.676} stopColor="#12a2ff" stopOpacity={0.055} />
          <stop offset={0.827} stopColor="#12a1ff" stopOpacity={0.012} />
          <stop offset={1} stopColor="#12a1ff" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={5.996}
          y1={9.667}
          x2={5.972}
          y2={9.667}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__f"
          x1={219.402}
          y1={52.162}
          x2={219.257}
          y2={52.162}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__g"
          x1={566.734}
          y1={79.329}
          x2={566.484}
          y2={79.329}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__h"
          x1={562.437}
          y1={77.802}
          x2={562.187}
          y2={77.802}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__i"
          x1={387.721}
          y1={67.14}
          x2={387.521}
          y2={67.14}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__j"
          x1={9.898}
          y1={10.52}
          x2={9.9}
          y2={10.531}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__k"
          x1={3.128}
          y1={2.334}
          x2={3.137}
          y2={2.335}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__l"
          x1={3.998}
          y1={10.186}
          x2={3.996}
          y2={10.207}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__m"
          x1={32.083}
          y1={16.431}
          x2={32.351}
          y2={16.63}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__n"
          x1={5.403}
          y1={5.209}
          x2={5.439}
          y2={5.213}
          xlinkHref="#prefix__a"
        />
        <style>
          {
            ".prefix__b,.prefix__w{fill:none}.prefix__b{stroke:#fff;stroke-width:1.575px;stroke-miterlimit:10}.prefix__f{fill:#303030}.prefix__h{fill:#000001}.prefix__n{fill:#515151}.prefix__s{fill:#bcbcbc}"
          }
        </style>
      </defs>
      <g transform="translate(-301.895 -523.551)">
        <g opacity={0.15}>
          <path
            className="prefix__b"
            d="M688.411 650.548c2.41 0 3.686 0 3.679.008q-1.084-1.485-2.2-2.956"
          />
          <path
            d="M686.703 643.48c-43.04-54.246-115.035-93.238-189.015-93.238-75.172 0-156.032 39.093-191.779 95.766"
            strokeDasharray="15.922 11.146"
            strokeMiterlimit={10}
            stroke="#fff"
            strokeWidth={1.575}
            fill="none"
          />
          <path
            className="prefix__b"
            d="M304.544 648.218q-.955 1.577-1.862 3.172c-.015-.011 1.261-.023 3.678-.037"
          />
          <path
            d="M311.53 651.328c53.136-.23 329.08-.758 374.29-.779"
            strokeDasharray="15.804 11.063"
            strokeMiterlimit={10}
            stroke="#fff"
            strokeWidth={1.575}
            fill="none"
          />
        </g>
        <path
          d="M682.43 652.002a231.3 231.3 0 00-374.5.83c-.263-.185 374.621-.921 374.5-.83z"
          fill="#393939"
        />
        <circle
          className="prefix__f"
          cx={9.575}
          cy={9.575}
          r={9.575}
          transform="translate(488.849 602.565)"
        />
        <circle
          className="prefix__f"
          cx={12.521}
          cy={12.521}
          r={12.521}
          transform="translate(407.9 599.619)"
        />
        <circle
          className="prefix__f"
          cx={6.032}
          cy={6.032}
          r={6.032}
          transform="translate(430.525 631.149)"
        />
        <circle
          className="prefix__f"
          cx={8.47}
          cy={8.47}
          r={8.47}
          transform="translate(551.084 582.311)"
        />
        <circle
          className="prefix__f"
          cx={6.079}
          cy={6.079}
          r={6.079}
          transform="translate(581.273 623.772)"
        />
        <circle
          className="prefix__f"
          cx={5.553}
          cy={5.553}
          r={5.553}
          transform="translate(537.061 623.526)"
        />
      </g>
      <path
        d="M340.689 486.972c-1.623 1.078-4.818 3.269-8.01 4.955-1.665.881-2.646.842-3.36.519a1.171 1.171 0 00.377.619c2.764 1.776 8.24-.348 9.667-1.83s6.454-4.583 6.8-6.012l.011-.055c-1.39-1.76-4.066.862-5.485 1.804z"
        transform="rotate(-19.01 -821.003 110.297)"
        fill="url(#prefix__a)"
      />
      <path
        className="prefix__h"
        d="M394.303 95.285c2.47-2.636 4.778-5.75 5.961-7.3 1.034-1.353 2.717-4.708 4.599-3.49-.21-1.438-2.97-2.64-4.529-3.899a4.111 4.111 0 01-.379-.357c-1.797 1.38-3.822 6.414-4.065 7.293-.136.497-.716.257-1.246-.09a17.41 17.41 0 01-2.743 7.198c-.898 1.143-.848 1.838-.606 2.234.779.07 1.719-.215 3.008-1.589z"
      />
      <path
        d="M327.249 248.011c3.4-.189 3.329-2.853 3.33-2.857-.919-3.873-2.22-4.469-4.328-5.762a5.069 5.069 0 00-2.695-.675c-2.138.357-2.858 1.555-3.874 2.778-1.359 1.637-5.6 10.076-5.851 10.313a.467.467 0 00-.063.564c-.662.8-6.324 7.551-6.78 8.036a22.06 22.06 0 00-2.583 2.823 12.463 12.463 0 01-3.8 2.863c-.979.447-.9.873-.915 1.528s-.12.8-.627 1.62.148 2.008.4 2.565.65 1.1.924 1.093.186-.783.186-.783a7.921 7.921 0 01.788.632c.153.174.416.446.626.226s.1-.775.1-.775.242.32.376-.131-.718-1.568-.718-1.568c1.252.571.811-.854.811-.854s1.483-1.233 1.911-1.474 1.045-2.172 1.608-2.853a40.844 40.844 0 015.859-4.263 48.552 48.552 0 006.137-5.207c1.076 1.1 2.311-1.743 3.343-2.77s2.436-4.88 5.835-5.069z"
        transform="rotate(-19.01 -315.855 -49.73)"
        fill="url(#prefix__b)"
      />
      <path
        d="M318.642 236.733l1.2-6.192 3.084-.233 2.663 3.421z"
        transform="matrix(.946 -.326 .326 .946 .105 -99.804)"
        fill="url(#prefix__c)"
      />
      <path
        className="prefix__h"
        d="M383.253 12.557a3.575 3.575 0 01.015-3.444 10.424 10.424 0 00-11.82-4.946 9.177 9.177 0 00-6.561 11.198q.084.323.192.64a10.348 10.348 0 009.585 6.93c2.327-2.424 7.951-8.428 8.59-10.378z"
      />
      <path
        d="M364.088 192.74c-1.77-.3-6.722 3.311-7.109 8.362q-.026.333-.027.668a10.342 10.342 0 006.8 9.669c.041-.109-6.746-10.439.336-18.699z"
        transform="rotate(-19.01 -193.736 85.268)"
        fill="url(#prefix__d)"
      />
      <path
        d="M374.665 22.935c2.326-2.425 7.95-8.43 8.587-10.377a3.576 3.576 0 01.014-3.446 10.424 10.424 0 00-11.819-4.946 9.416 9.416 0 00-5.19 3.607l8.564 5.596-1.865 9.386a10.406 10.406 0 001.709.18z"
        fill="#7c7c7c"
      />
      <path
        d="M317.372 207a10.4 10.4 0 002.585.863c3.432-1.806 8.843-4.791 9.9-6.179a3.6 3.6 0 011.271-3.378 10.345 10.345 0 00-9.683-9.458 9.406 9.406 0 00-6.612 2.106l6.793 8.753z"
        transform="matrix(.946 -.326 .326 .946 5.464 -70.7)"
        fill="url(#prefix__e)"
      />
      <path
        className="prefix__n"
        d="M377.306 17.01a1.427 1.427 0 01-.84 1.834l-.095.033a1.618 1.618 0 01-1.925-1.07 1.428 1.428 0 01.85-1.836l.094-.033a1.614 1.614 0 011.916 1.073z"
      />
      <path
        d="M345.012 237.908a1.406 1.406 0 01-1.282-1.428 1.249 1.249 0 011.222-1.276h.084a1.414 1.414 0 011.282 1.43 1.245 1.245 0 01-1.215 1.274.69.69 0 01-.091 0z"
        transform="rotate(-19.01 -293.978 35.54)"
        fill="url(#prefix__f)"
      />
      <path
        d="M383.268 9.114a10.424 10.424 0 00-11.82-4.946 9.418 9.418 0 00-5.189 3.607"
        stroke="#bcbcbc"
        strokeWidth={0.061036599999999996}
        strokeMiterlimit={10}
        fill="none"
      />
      <path
        d="M338.263 192.039c.2-.022.9.424.875.67s-.418.906-.573.919-.935-.19-.979-.364.424-1.197.677-1.225z"
        transform="rotate(-19.01 -207.626 -6.524)"
        fill="url(#prefix__g)"
      />
      <path
        d="M325.514 199.809c.195-.025.9.421.873.669s-.42.9-.573.919-.933-.189-.981-.365.424-1.196.681-1.223z"
        transform="rotate(-19.01 -232.236 -53.092)"
        fill="url(#prefix__h)"
      />
      <path
        className="prefix__s"
        d="M374.36 3.59a1.445 1.445 0 00-.965-.238c-.162.074-.264.646-.28 1.033a2.101 2.101 0 001.001-.008c.103-.05.215-.473.245-.786zM378.666 4.532a1.44 1.44 0 00-.964-.24c-.164.075-.266.646-.279 1.033a2.09 2.09 0 00.996-.012c.108-.047.218-.465.247-.781z"
      />
      <g>
        <path
          className="prefix__n"
          d="M376.19 13.218a1.08 1.08 0 01-.632 1.39c-.027.008-.054.018-.08.027a1.225 1.225 0 01-1.46-.81 1.084 1.084 0 01.643-1.394l.07-.024a1.224 1.224 0 011.458.811z"
        />
        <path
          d="M344.03 225.129a1.02 1.02 0 01-.926-1.035.9.9 0 01.883-.924h.06a1.026 1.026 0 01.933 1.036.9.9 0 01-.885.923z"
          transform="rotate(-19.01 -269.415 26.755)"
          fill="url(#prefix__i)"
        />
        <path
          d="M375.342 13.252l-.233-.104.558-1.477.238.105z"
          fill="#202729"
        />
      </g>
      <path
        d="M328.584 220.849l-.005-.045c-2.661 1.884-8.725 4.45-10.217 2.676l-3.532 6.062a10.4 10.4 0 002.585.863c3.432-1.806 8.843-4.79 9.9-6.179a3.611 3.611 0 011.269-3.377z"
        transform="matrix(.946 -.326 .326 .946 .517 -92.855)"
        fill="url(#prefix__j)"
      />
      <path
        className="prefix__w"
        d="M400.597 32.68a12.769 12.769 0 011.655.445c1.855.624 3.232-.528 4.383-1.308a21.013 21.013 0 00-5.776.791c-.091.024-.173.048-.262.073z"
      />
      <path
        className="prefix__w"
        d="M400.597 32.68a12.769 12.769 0 011.655.445c1.855.624 3.232-.528 4.383-1.308a21.013 21.013 0 00-5.776.791c-.091.024-.173.048-.262.073z"
      />
      <path
        d="M240.05 239.612c-2.765-.085-5.045 2.759-5.045 2.759l-1.919.625-.231 6.917.933.627.859 2.274 4.844 10.63a.856.856 0 01.693.8c-.675.355-1.166.618-1.166.618a2.569 2.569 0 00-1.631 1.961.89.89 0 00-.758.873 1.722 1.722 0 00-1.7.719c-.124.032-.6.686-.9.893-.017.01-.036.024-.057.035h-.007c-2.727 1.655-5.259 3.262-5.833 3.709-1.259.979-2.092.478-3.531 1.156a2.613 2.613 0 00-1.357 1.368 4.949 4.949 0 00-3.42 6.121c.213.6 1.7 3.419 2.73 5.257a153.346 153.346 0 016 14.814c.439 1.863.477 7.244-.551 9.671-.178.422-.4.883-.663 1.363.423.543.932.993 1.25.533.562-.814 4.421-5.27 6.752-6.049a15.809 15.809 0 01-.9-5.264 15.283 15.283 0 002.462-.829 14.472 14.472 0 00-.757-4.387 85.714 85.714 0 01-2.779-9.72 20.306 20.306 0 00-1.078-5.432 4.381 4.381 0 01.487-.291 10.161 10.161 0 002.4 3.379c.84.732 3.671.361 4.879.092s1.7.614 2.387-.135 2.45.268 9.634 1.581a35.189 35.189 0 0114.362 6.1 3.727 3.727 0 011.572 1.893 11.276 11.276 0 012.427-2.629c1.276-.782-1.061-3.782-.532-6.056-2.022-.219-6.153-2.275-6.153-2.275a27.973 27.973 0 00-.107-2.8c-.108-.4-.738-.56-3.287-1.006a59.18 59.18 0 01-6.288-1.856 10.077 10.077 0 002.991-3.386c.086-.153.169-.307.239-.461.514-1.113 3.485-3.3 2.469-9.172-.189-1.1-.63-1.477-1.23-1.529a8.4 8.4 0 01-.781-1.745 8.548 8.548 0 00-3.478-3.947c.483-.334-5.253-11.943-5.253-11.943.087-.656-1.339-1.856-1.339-1.856-3.424-4.088-4.877-3.912-7.639-4z"
        transform="rotate(-19.01 -359.311 -297.65)"
        fill="url(#prefix__k)"
      />
      <path
        d="M356.827 246.54c-3.044.982-11.84 1.747-16.924.145 0 0-2.695-.056-2.717-1.234a11.506 11.506 0 01-3.34-1.023c-1.677-.828-9.314-5.845-10.629-6.673s-2.693-1.063-3.6-1.9-1.942-1.4-2.927-.9c0 0-.833-.065-.272-.585a.5.5 0 00-.547.041c-.217.215-.542-.207-.17-.744s.758-1.825 2.3-2.013a1.438 1.438 0 00-1.114-.044c-.552.24-.894.06-.957-.162s.34-.595.857-.724a3.27 3.27 0 012.6-.027c1.089.567 2.659.981 3.229 2.075a4.4 4.4 0 001.642 1.989c.5.23 4.11 1.974 6.748 3.049s5.535 1.95 6.269 2.638c0 0 .167-.231 1.24-.05s1.55-.259 2.272.374a23.923 23.923 0 015.125.4 7.024 7.024 0 012.687-.4c.978.189 3.5-1.515 4.382-1.951s6.627-5.353 8.913 1.276-5.067 6.443-5.067 6.443z"
        transform="rotate(-19.01 -280.071 56.851)"
        fill="url(#prefix__l)"
      />
      <g>
        <path
          className="prefix__h"
          d="M427.92 54.18a10.948 10.948 0 00-1.4 3.186 4.234 4.234 0 001.565 1.643c1.725.934 2.307 4.38 2.473 5.913s.75 2.388 1.89 2.327c-.754-.122.389-4.55.276-7.398-.107-2.674-1.149-10.578-.87-13.388-.97-.47-4.385 1.405-5.819 2.142a2.301 2.301 0 01-.522.18c.23 2.26 3.33 4.278 2.406 5.394z"
        />
        <path
          d="M200.082 414.43c3.5 1.011 4.7-5.749 4.63-7.633a23.577 23.577 0 011.043-6.185c.354-1.069 1.257-5.182.565-5.99a.1.1 0 00-.031-.028c-1.177 2.565-2.767 10.372-3.537 12.934-.821 2.73-3.341 6.541-2.67 6.902z"
          transform="rotate(-19.01 -720.514 -452.151)"
          fill="url(#prefix__m)"
        />
      </g>
      <path
        d="M255.858 251.336c3.274-1.542 12.813-3.187 8.3-7.683s-1.176-6.058-3.435-10.909-5.151-14.875-9.609-15.55-13.06 2.871-12.733 8.333 17.477 25.809 17.477 25.809z"
        transform="rotate(-19.01 -311.927 -305.386)"
        fill="url(#prefix__n)"
      />
    </svg>
  );
}

export default Nodata;
